export class UpdateEvalModel {
    public inspectionId: number;
    public newEval: string;
}

  export class UpdateObservationListPhotoModel {
    public ObservationId: number;
    public PhotoData: string;
    public photoId:number;

    /**
     *
     */
    constructor( id: number, data: string,PhotoId:number) {
      this.ObservationId = id;
      this.PhotoData  = data;
      this.photoId=PhotoId;
    }
  }
